import { InjectionToken } from '@angular/core';

export type LinkClickData = { linkName: string; linkType: string; linkKey?: string };

export type ClickTrackProvider = {
    trackLinkClick: (data: LinkClickData) => void;
};

export const CLICK_TRACK_PROVIDER = new InjectionToken<ClickTrackProvider>('clickTrackProvider');
